module.exports = __webpack_public_path__ + "img/offer3.d992f8d5.png";